exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  background: #f2f2f2;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  height: 100%;\n  overflow: hidden;\n  overflow-y: scroll;\n  box-shadow: 2px 2px 2px 2px rgba(101, 121, 131, 0.4);\n}\n@media (max-width: 767px) {\n  .overlay {\n    position: relative;\n    top: auto;\n    right: auto;\n    height: auto;\n    box-shadow: none;\n  }\n}\n.overlay h3 {\n  margin-bottom: 20px;\n  margin-top: 0;\n}\n.overlay-inner {\n  padding: 20px;\n}\n.form-control,\n.input-group {\n  margin-bottom: 20px;\n}\n@media (max-width: 767px) {\n  .form-control,\n  .input-group {\n    width: 100%;\n  }\n}\n.input-group .form-control {\n  margin-bottom: 0;\n  width: 100%;\n}\nlabel {\n  text-transform: uppercase;\n}\ntextarea {\n  height: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/mailbox-reply/mailbox-reply.component.less
// module id = ../../../../../src/app/mailbox-reply/mailbox-reply.component.less
// module chunks = 1